export const pageFeature = {
    // ロード完了したとき
    loadDone: function (results) {
        //初回画像読み込み
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);
        $(".nursery-feature__list-container").map(function () {
            const imageId = $(this).data("feature-id");
            pageFeature.getItem(imageId);
        });

        modalWindow.enableButton();
        pageFeature.enableButtons();
        pageFeature.enableAddButton();
    },
    // POST完了
    postDone: function () {
        $("#js-nav-pagetop").trigger("click");
    },
    // 特徴の一行を取得する。
    getItem: function (itemId) {
        const paramList = new FormData();
        paramList.append("id", itemId);

        post.postAjaxData("/nursery/feature/getItem", paramList, "", pageFeature.getImageDone, null, null);
    },

    // 画像イメージが読み込まれたときの各種ボタンの定義
    getImageDone: function (results, paramList) {
        $('[data-feature-id="' + paramList.get("id") + '"]').html(results["template"]);

        modalWindow.enableButton();
        pageFeature.enableButtons();
        pageFeature.enableAddButton();
    },

    // ボタンを有効にする。
    enableButtons: function () {
        // 削除ボタンが押された。
        $(".js-btn-delete").click(function () {
            const deleteTargetId = $(this).data("id");
            $(".button-small--yes").data("deleteTargetId", deleteTargetId);
        });

        // 削除OKボタンが押されたとき
        $(".button-small--yes").click(function () {
            const paramList = new FormData();
            const deleteTargetId = $(this).data("deleteTargetId");
            paramList.append("id", deleteTargetId);

            post.postAjaxData(
                "/nursery/feature/delete",
                paramList,
                "特徴を削除しました",
                pageFeature.deleteDone,
                null,
                null
            );
        });

        // 特徴を追加、編集を押したとき
        $(".js-btn-edit").unbind();
        $(".js-btn-edit").click(function () {
            const paramList = new FormData();
            paramList.append("id", $(this).data("id"));

            post.postAjaxData("/nursery/feature/update", paramList, "", pageFeature.updateLoadDone, null, null);
        });

        // 上下移動ボタンを押したとき
        $(".button-sort").unbind();
        $(".button-sort").click(function () {
            // 位置を変更
            if ($(this).hasClass("button-sort--up")) {
                const insert = $(this)
                    .parents(".nursery-feature__list-container")
                    .prev(".nursery-feature__list-container");
                if (insert) {
                    const targetObject = $(this).parents(".nursery-feature__list-container");
                    $(insert).insertAfter(targetObject);
                }
            } else {
                const insert = $(this)
                    .parents(".nursery-feature__list-container")
                    .next(".nursery-feature__list-container");
                if (insert) {
                    const targetObject = $(this).parents(".nursery-feature__list-container");
                    $(insert).insertBefore(targetObject);
                }
            }

            pageFeature.updatePosition("移動が完了しました");
        });
    },

    updatePosition: function (message) {
        // 位置を決定する。
        let position = 1;
        const paramList = new FormData();
        $(".nursery-feature__list-container").map(function () {
            const imageId = $(this).data("feature-id");
            paramList.append("id[" + position + "]", imageId);
            position++;
        });

        post.postAjaxData("/nursery/feature/updatePosition", paramList, message, null, null, null);
    },
    // 更新ボタンをおしてロードが完了
    updateLoadDone: function (results) {
        $("#js-feature-modal-area").html(results["template"]);
        modalWindow.showModal("#js-modal-edit");

        // ボタンの有効化
        modalWindow.enableButton();
        pageFeature.enableButtons();

        // 画像プレビュー
        imagePreview.preview(".nursery-feature__modal-right", ".nursery-feature__modal-pict");

        // 保存ボタンを押したとき
        $(".js-upload-button").unbind();
        $(".js-update-button").click(function () {
            form.disableButtons(this);

            const url = $("#featureForm").attr("action");
            form.post(url, "#featureForm", "特徴の更新が完了しました", function (results) {
                pageFeature.uploadDone(results);
                modalWindow.hideModal("#js-modal-edit");
            });
        });

        // 削除ボタンの定義
        $(".js-image-delete").unbind("click");
        $(".js-image-delete").click(function () {
            imagePreview.deleteImage(".nursery-feature__modal-pict");
        });
    },

    // 更新が完了
    uploadDone: function (results) {
        const featureId = results["featureId"];

        if ($('[data-feature-id="' + featureId + '"]').length !== 0) {
            $('[data-feature-id="' + featureId + '"]').html(results["template"]);
        } else {
            // 枠を一番下に追加
            $(".nursery-feature__list-container--add").before(results["template"]);
        }
        pageFeature.getItem(featureId);

        pageFeature.updatePosition("");
    },
    // 削除が完了した
    deleteDone: function (results, paramList) {
        $('[data-feature-id="' + paramList.get("id") + '"]').remove();
        pageFeature.enableAddButton();

        pageFeature.updatePosition("");
    },

    // 数をチェックして追加ボタンの有無。
    enableAddButton: function () {
        if ($(".nursery-feature__list-container").length >= 3) {
            $(".nursery-feature__list-container--add").hide();
        } else {
            $(".nursery-feature__list-container--add").show();
        }
    }
};
